import React from 'react';
import { ListItem } from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';

const pt = PropTypes;

const SalientIconItem = (props) => {
  const { iconData } = props;
  const { icon: IconComponent, text, alt } = iconData;

  return (
    <ListItem className="sui-list-none !sui-p-0 sui-text-base sui-leading-normal sui-font-regular sui-flex sui-flex-row sui-items-center sui-w-full sm:sui-w-40 lg:sui-w-full">
      <div
        className="sui-w-8 sui-h-8 sui-flex-shrink-0 sui-flex sui-items-center sui-justify-center"
        role="img"
        aria-label={alt}
      >
        <IconComponent
          className="sui-w-full sui-h-full"
          style={{
            width: '32px',
            height: '32px',
            maxWidth: '32px',
            maxHeight: '32px',
            display: 'block'
          }}
          aria-hidden="true"
        />
      </div>
      <span className="sui-ml-2 sui-text-wrap sui-line-clamp-2">{text}</span>
    </ListItem>
  );
};

SalientIconItem.displayName = 'SalientIconItem';

SalientIconItem.propTypes = {
  iconData: pt.shape({
    icon: pt.func.isRequired,
    text: pt.string.isRequired,
    alt: pt.string.isRequired
  }).isRequired
};

export { SalientIconItem };
